export const insufficientPointSheet = {
  title: "ポイントが不足しています",
  balanceLabel: "所持ポイント",
  neededLabelLive: "視聴に必要",
  neededLabelCall: "通話に必要",
  neededLabel: "必要",
  unitPerMin: "pt/分",
  chargeSuffix: "でチャージ",
  payNote: "アプリ内課金でお支払い",
  doneTitle: "チャージ完了！",
  doneDesc: (args: { point: string | number }) =>
    `${args.point}ptを獲得しました`,
  // 通話中・ライブ視聴中にまず表示する控えめな通知バナーの文言
  notice: {
    title: "まもなくポイントが不足します",
    subtitle: "タップしてポイントをチャージ",
    // ◯回目限定プラン（購入ボーナスコース）が有効なときだけ subtitle の上に追加する一言
    bonusSubtitle: (args: { name: string }) =>
      `${args.name}さんだけに限定のプランがあります`,
  },
  // 限定プランカードのお得ptバースト（例: 450pt お得↑）
  savingBadge: {
    amount: (args: { points: string | number }) => `${args.points}pt`,
    label: "お得↑",
  },
  // 限定プランカードの pt 横に添える小タグ
  limitedTag: "限定",
  // シーン別の増量訴求（通常比でどれだけ多くできるか）。CTA 上のピルで使用。
  // 数量部分を強調表示するため prefix / count / suffix に分割している
  gainPrefix: "通常よりも",
  // ピルの「通常」の真上に出す通常ポイント明記の吹き出し（例: 550pt）
  gainRegularBubble: (args: { points: string | number }) => `${args.points}pt`,
  scene: {
    chat: {
      gainCount: (args: { count: string | number }) => `${args.count}通`,
      gainSuffix: "も多く送れます",
    },
    video: {
      gainCount: (args: { count: string | number }) => `約${args.count}分`,
      gainSuffix: "も多く話せます",
    },
    voice: {
      gainCount: (args: { count: string | number }) => `約${args.count}分`,
      gainSuffix: "も多く話せます",
    },
    live: {
      gainCount: (args: { count: string | number }) => `約${args.count}分`,
      gainSuffix: "も多く見れます",
    },
    gift: {
      gainCount: (args: { count: string | number }) => `${args.count}個`,
      gainSuffix: "も多く送れます",
    },
    image: {
      gainCount: (args: { count: string | number }) => `${args.count}枚`,
      gainSuffix: "も多く見れます",
    },
    movie: {
      gainCount: (args: { count: string | number }) => `${args.count}本`,
      gainSuffix: "も多く見れます",
    },
    audio: {
      gainCount: (args: { count: string | number }) => `${args.count}件`,
      gainSuffix: "も多く聴けます",
    },
  },
} as const;
